import { render } from "./TheChangeInformation.vue?vue&type=template&id=6ef02fa6"
import script from "./TheChangeInformation.vue?vue&type=script&lang=js"
export * from "./TheChangeInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__